import * as React from 'react';
import * as _ from 'lodash';
import { Dropdown } from 'react-input-enhancements';
import SearchBar from '../components/SearchBar';
import { cleanProps } from '../utilities/props';
import { GlobalHeaderButtons } from '../components/PageLayout/GlobalHeaderButtons';
import { MaterialsFiltersContainer } from '../components/StoneSetup/materialsFilter';
export default function (props, context) {
    function onChange1(e) {
        props.setSearchTerm(e.target.value);
    }
    return React.createElement('div', _.assign({}, cleanProps(props)), React.createElement(GlobalHeaderButtons, {}), React.createElement('div', { 'className': 'lightbox-header-container' }, React.createElement('div', { 'className': 'lightbox-title-block' }, React.createElement('h1', { 'id': 'PageTitle' }, 'Stone Setup'), React.createElement('p', {}, 'Modify the price, name, and availability of stones. Use the Material and Color filters to narrow the\r\n        selection.'))), React.createElement(SearchBar, {
        'value': props.term,
        'componentClassName': 'app-search--with-desc',
        'onChange': onChange1.bind(this)
    }));
}